import React, { useState, useEffect } from "react";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import Boost from "highcharts/modules/boost";
import { formatDisplayDate } from "../../../utilities/CommonUtilities";

const ChartComponent = ({
  dashboardName,
  dashboardChartData,
  legends,
  handlePointClick,
}) => {
  const [monthlyData, setMonthlyData] = useState(false);

  useEffect(() => {
    if (dashboardName === "GEOPOLITICAL_INDIA_V1") {
      setMonthlyData(true);
    }
  }, [dashboardName]);

  function groupByDateAndIsin(data) {
    return data.reduce((acc, [date, score, isin]) => {
      const dateObj = new Date(date);
      const month = dateObj.getMonth() + 1; // getMonth is zero-based
      const year = dateObj.getFullYear();
      const key = `${year}-${month.toString().padStart(2, "0")}`; // Format as YYYY-MM

      if (!acc[key]) {
        acc[key] = { date, isin, score: 0 };
      }

      if (acc[key].isin === isin) {
        acc[key].score += score;
      } else {
        // Handle multiple ISINs case or log warning
      }

      return acc;
    }, {});
  }
const processData = (data) => {
  let processedSeries;

  if (data.length > 0 && monthlyData) {
    const updated = data.map((dataPoint) => {
      const data = dataPoint.data.map((entry) => {
        return [entry[0], entry[1], entry[2]];
      });
      return {
        name: dataPoint.name,
        country: dataPoint.country,
        isin: dataPoint.isin,
        data: groupByDateAndIsin(data),
      };
    });

    processedSeries = updated.map((series) => {
      const data = Object.values(series.data).map((x) => [
        new Date(x.date),
        x.score,
        x.isin,
      ]);

      return {
        ...series,
        data: series.data,
        keys: ["x", "y", "isin"],
      };
    });
  } else {
    processedSeries = dashboardChartData.map((series) => {
      const data = series.data.map((x) => [
        new Date(x[0]),
        parseFloat(x[1].toFixed(3)), // Rounding the score to 3 decimal places
        x[2],
      ]);

      return {
        ...series,
        data: data,
        keys: ["x", "y", "isin"],
      };
    });
  }
 
  // Sort series alphabetically by name
  return processedSeries.sort((a, b) => a.name.localeCompare(b.name));
};

  Boost(Highcharts);

  const options = {
    chart: {
      type: "line",
      zoomType: "x",
    },
    boost: {
      useGPUTranslations: true,
      usePreAllocated: true,
    },
    accessibility: {
      enabled: false,
    },
    title: {
      text: `Scores`,
    },
    xAxis: {
      type: "datetime",
      dateTimeLabelFormats: {
        day: "%e %b %Y",
        month: "%b '%y",
        year: "%Y",
      },
    },
    yAxis: {
      title: {
        text: "Score",
      },
    },
    legend: legends
      ? {
          align: "right",
          verticalAlign: "middle",
          layout: "vertical",
        }
      : false,
    plotOptions: {
      series: {
        cursor: "pointer",
        point: {
          events: {
            click: function () {
              if (handlePointClick) {
                handlePointClick(this);
              }
            },
          },
        },
      },
    },
    credits: {
      enabled: false
    },
    tooltip: {
      formatter: function () {
        return (
          "<b>" +
          this.series.name +
          "</b><br>" +
          "Date: " +
          formatDisplayDate(this.x) +
          "<br>" +
          "Score: " +
          this.y
        );
      },
    },
    series: processData(dashboardChartData),
  };

  return (
    <>
      <div className="overflow-auto w-100 h-100">
        <HighchartsReact
          highcharts={Highcharts}
          options={options}
          containerProps={{ style: { height: "100%", width: "100%" } }}
        />
      </div>
    </>
  );
};

export default ChartComponent;
